export default "__VITE_ASSET__QvMwWBAo__"